import { isNumber } from "./utils/utils"

export function roundArea(area: number) {
    return isNumber(area) ? Math.round(area * 100) / 100 : area
}
